"use client";
// Imports
import { useState, useEffect } from "react";
import { Button } from "../../ui/button";
import { ArrowLeft, ArrowRight } from "lucide-react";
import useStore from "@/lib/state";

// Pagination
export function Pagination({
  results: { startAmount, endAmount, totalResults },
}) {
  const { setPageBy, pageBy, setCurrentPage, currentPage } = useStore();
  const [previousDisabled, setPreviousDisabled] = useState(false);

  function goPrevious() {
    const gridContainer = document.getElementById("grid_container");
    gridContainer.scrollIntoView({ behavior: "instant" });

    // Adjust the scroll position to offset for the header height and an additional 100px
    const headerHeight = document.querySelector("header").offsetHeight;
    window.scrollBy(0, -(headerHeight + 120));
    setCurrentPage(currentPage - 1);
  }

  function goNext() {
    const gridContainer = document.getElementById("grid_container");
    gridContainer.scrollIntoView({ behavior: "instant" });

    // Adjust the scroll position to offset for the header height and an additional 100px
    const headerHeight = document.querySelector("header").offsetHeight;
    window.scrollBy(0, -(headerHeight + 120));
    setCurrentPage(currentPage + 1);
  }

  useEffect(() => {
    if (currentPage == 1) {
      setTimeout(() => {
        setPreviousDisabled(true);
      }, 1000);
    } else {
      setPreviousDisabled(false);
    }
  }, [currentPage]);

  const paginationButtonColors = {
    background: "#892102",
    foreground: "#FFFFFF",
  };

  // Render
  return (
    <div className="flex items-center justify-between space-x-4">
      <Button
        disabled={previousDisabled}
        onClick={goPrevious}
        customColors={paginationButtonColors}
      >
        <ArrowLeft width={24} />
      </Button>
      <div>
        <p className="text-center">
          Showing{" "}
          <span>
            {startAmount}-{endAmount}
          </span>{" "}
          of <span>{totalResults} results</span>
        </p>
      </div>
      <Button
        disabled={totalResults - startAmount <= pageBy}
        onClick={goNext}
        customColors={paginationButtonColors}
      >
        <ArrowRight width={24} />
      </Button>
    </div>
  );
}
